/* Corlanza — catálogo corregido: galería, oferta, opción (color/tamaño) y carrito lateral. Sin dependencias. */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var state = { qty: 1, optName: null, opt: null };
  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* Carrito lateral */
  function drawer() { return $('[data-cz-drawer]'); }
  function openCart() { var d = drawer(); if (!d) return; d.hidden = false; document.body.classList.add('cz-lock'); }
  function closeCart() { var d = drawer(); if (!d) return; d.hidden = true; document.body.classList.remove('cz-lock'); }
  function renderCart(html) {
    if (!html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = $('[data-cz-drawer]', tmp), old = drawer();
    if (fresh && old) {
      var open = !old.hidden;
      old.innerHTML = fresh.innerHTML;
      old.setAttribute('data-cz-n', fresh.getAttribute('data-cz-n'));
      old.hidden = !open;
    }
    var n = old ? old.getAttribute('data-cz-n') : null;
    if (n !== null) $$('[data-cz-count]').forEach(function (el) { el.textContent = n; });
  }
  function post(url, body) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'No se pudo agregar al carrito');
        return j;
      });
    });
  }
  function add(id, qty, props) {
    var item = { id: Number(id), quantity: qty };
    if (props) item.properties = props;
    return post('cart/add.js', { items: [item], sections: 'cz-carrito', sections_url: window.location.pathname })
      .then(function (res) { renderCart(res.sections && res.sections['cz-carrito']); return res; });
  }
  function removeLine(key) {
    return post('cart/change.js', { id: key, quantity: 0, sections: 'cz-carrito', sections_url: window.location.pathname })
      .then(function (res) { renderCart(res.sections && res.sections['cz-carrito']); });
  }

  /* Ficha */
  function gallery() { return $('[data-cz-gal]'); }
  function showImg(i) {
    var g = gallery(); if (!g) return;
    var list = [];
    try { list = JSON.parse(g.getAttribute('data-cz-gal') || '[]'); } catch (e) {}
    if (!list.length) return;
    i = ((i % list.length) + list.length) % list.length;
    g.setAttribute('data-i', i);
    var img = $('img', g);
    if (img) { img.removeAttribute('srcset'); img.src = list[i]; }
    $$('[data-cz-thumb]').forEach(function (b, j) { b.classList.toggle('is-on', j === i); });
  }
  function selectOffer(btn) {
    $$('[data-cz-offer]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    state.qty = Number(btn.getAttribute('data-qty')) || 1;
    var price = btn.getAttribute('data-price'), compare = btn.getAttribute('data-compare');
    $$('[data-cz-price]').forEach(function (el) { el.textContent = price; });
    $$('[data-cz-compare]').forEach(function (el) { el.textContent = compare; });
  }
  function selectOpt(btn) {
    $$('[data-cz-opt]').forEach(function (b) {
      var on = b === btn;
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    state.opt = btn.getAttribute('data-cz-opt');
  }
  function props() {
    if (!state.optName || !state.opt) return null;
    var o = {}; o[state.optName] = state.opt; return o;
  }
  function showError(msg) { var e = $('[data-cz-error]'); if (e) e.textContent = msg; }

  document.addEventListener('click', function (ev) {
    var t = ev.target.closest('[data-cz-open-cart],[data-cz-close-cart],[data-cz-remove],[data-cz-quick],[data-cz-offer],[data-cz-opt],[data-cz-thumb],[data-cz-prev],[data-cz-next],[data-cz-buy],[data-cz-add]');
    if (!t || t.disabled) return;
    if (t.hasAttribute('data-cz-open-cart')) { ev.preventDefault(); openCart(); return; }
    if (t.hasAttribute('data-cz-close-cart')) { closeCart(); return; }
    if (t.hasAttribute('data-cz-remove')) {
      t.disabled = true;
      removeLine(t.getAttribute('data-cz-remove')).catch(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-cz-quick')) {
      var qp = null, qn = t.getAttribute('data-cz-quick-name'), qv = t.getAttribute('data-cz-quick-opt');
      if (qn && qv) { qp = {}; qp[qn] = qv; }
      t.disabled = true;
      add(t.getAttribute('data-cz-quick'), 1, qp).then(openCart)
        .catch(function (e) { alert(e.message); })
        .then(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-cz-offer')) { selectOffer(t); return; }
    if (t.hasAttribute('data-cz-opt')) { selectOpt(t); return; }
    if (t.hasAttribute('data-cz-thumb')) { showImg(Number(t.getAttribute('data-cz-thumb'))); return; }
    if (t.hasAttribute('data-cz-prev') || t.hasAttribute('data-cz-next')) {
      var g = gallery(); if (!g) return;
      var i = Number(g.getAttribute('data-i') || 0);
      showImg(t.hasAttribute('data-cz-prev') ? i - 1 : i + 1);
      return;
    }
    var p = $('[data-cz-product]');
    if (!p) return;
    var variant = p.getAttribute('data-cz-variant');
    showError('');
    if (t.hasAttribute('data-cz-add')) {
      t.disabled = true;
      add(variant, state.qty, props()).then(openCart)
        .catch(function (e) { showError(e.message); })
        .then(function () { t.disabled = false; });
      return;
    }
    if (t.hasAttribute('data-cz-buy')) {
      t.disabled = true;
      add(variant, state.qty, props()).then(function () { window.location.href = root + 'checkout'; })
        .catch(function (e) { showError(e.message); t.disabled = false; });
    }
  });
  document.addEventListener('keydown', function (ev) { if (ev.key === 'Escape') closeCart(); });
  document.addEventListener('DOMContentLoaded', function () {
    var box = $('[data-cz-opts]');
    if (box) state.optName = box.getAttribute('data-cz-opts');
    var on = $('[data-cz-opt].is-on');
    if (on) state.opt = on.getAttribute('data-cz-opt');
  });
})();
